import React from "react";
import BlockOfArticles from "src/components/common/BlockOfArticles/BlockOfArticles";
import { LastArticlesSchema } from "src/models/articles/getLastArticles";
import { useLastArticles } from "src/components/BlogListPage/hooks/useLastArticles";
import { Box } from "@mui/system";
import { Pagination, PaginationItem } from "@mui/material";
import Link from "src/components/common/Links/Link";

interface BlogListPageProps {
  articlesData: LastArticlesSchema;
  pageTitle?: string;
}

const BlogListPage: React.FC<BlogListPageProps> = ({
  articlesData,
  pageTitle,
}) => {
  const { data, currentPage, changePageHref, isLoading } =
    useLastArticles(articlesData);

  return (
    <>
      <BlockOfArticles
        isLoading={isLoading}
        title={pageTitle || "Последние статьи"}
        gridLg={3}
        lastArticlesData={articlesData.articles}
      />
      {data && data.paginator.totalPages > 1 && (
        <Box mt={3} display="flex" justifyContent="center" alignItems="center">
          <Pagination
            count={data.paginator.totalPages}
            page={Number(currentPage || 1)}
            color="secondary"
            renderItem={(item) => {
              if (item.disabled) return <PaginationItem {...item} />;

              return (
                <PaginationItem
                  component={Link}
                  scroll
                  href={changePageHref(item.page)}
                  shallow
                  {...item}
                />
              );
            }}
          />
        </Box>
      )}
    </>
  );
};

export default BlogListPage;
